/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  AppControllerRedirectToMobileAppQueryResponse,
  AppControllerRedirectToMobileApp404,
} from '../../types/AppControllerRedirectToMobileApp.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { appRedirectToMobileApp } from '../../methods/appRedirectToMobileApp.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const appRedirectToMobileAppQueryKey = () => [{ url: '/api/mobile-app' }] as const;

export type AppRedirectToMobileAppQueryKey = ReturnType<typeof appRedirectToMobileAppQueryKey>;

export function appRedirectToMobileAppQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = appRedirectToMobileAppQueryKey();
  return queryOptions<
    AppControllerRedirectToMobileAppQueryResponse,
    ResponseErrorConfig<AppControllerRedirectToMobileApp404>,
    AppControllerRedirectToMobileAppQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return appRedirectToMobileApp(config);
    },
  });
}

/**
 * {@link /api/mobile-app}
 */
export function useAppRedirectToMobileApp<
  TData = AppControllerRedirectToMobileAppQueryResponse,
  TQueryData = AppControllerRedirectToMobileAppQueryResponse,
  TQueryKey extends QueryKey = AppRedirectToMobileAppQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        AppControllerRedirectToMobileAppQueryResponse,
        ResponseErrorConfig<AppControllerRedirectToMobileApp404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? appRedirectToMobileAppQueryKey();

  const query = useQuery(
    {
      ...appRedirectToMobileAppQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<AppControllerRedirectToMobileApp404>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
